// Mounts the staff chat live hub once in the app shell. With the `?x=staff-chat` switch off it opens no connection.
import { isStaffChatOn } from '@/staff-chat/lib/staff-chat-switch';
import { useStaffChatHub } from '@/staff-chat/realtime/use-staff-chat-hub';

export function StaffChatHubMount() {
  useStaffChatHub(isStaffChatOn());
  return null;
}
